<div class="boviclic-container pt-5">
  <div class="ibox">
    <div class="text-center justify-content-center">
      <img style="width: 400px; height: auto;"  src="../../../assets/img/logos/provalt.png" alt="Boviclic">
    </div>

    <div class="ibox-head justify-content-center">
      <div class="ibox-title text-uppercase text-center" i18n="@@boviclicTitle">
        Removal request from Boviclic to validate
      </div>
    </div>

    <div class="ibox-body">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="alert alert-danger">
          <div class="d-flex flex-column flex-sm-row align-items-center align-items-sm-start">
            <em class="fa fa-exclamation-triangle fa-3x alert-icon pr-sm-3"></em>
            <div>
              <h6>{{data.message}}</h6>
              <h6 *ngIf="!data.showContact" i18n="@@boviclicErrorContactIT">
                If the problem persists please contact the IT department.
              </h6>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4" *ngIf="data.showContact">
        <app-display-contact></app-display-contact>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-4">
        <app-display-go-home></app-display-go-home>
      </div>
    </div>
  </div>
</div>
